import React, { useEffect, useRef, useState } from "react";
import mobileImage from "../Image/hero_sec_img.png";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AppStore from '../Image/Play-Store.png'
import PlayStore from '../Image/App-Store.png'

const HeroSection = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const sectionElement = sectionRef.current;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrollingDown(currentScrollY > lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && isScrollingDown) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionElement) {
      observer.observe(sectionElement);
    }

    return () => {
      if (sectionElement) {
        observer.unobserve(sectionElement);
      }
    };
  }, [lastScrollY, isScrollingDown]);

  return (
    <section className="application pt-5 p-lg-0" ref={sectionRef}>
      <Container>
        <Row>
          <Col
            sm={12}
            md={6}
            className="p-0 px-lg-0 px-md-0 px-3 align-self-center text-lg-start text-md-start text-center"
          >
            <p
              className={`DownloadappTxt1 mb-lg-3 mb-md-3 mb-sm-2 mb-1 animate__animated ${
                isInView ? "animate__fadeIn" : ""
              }`}
            >
              {t("heroSection.title")}
            </p>
            <h2
              className={`DownloadappTxt2 mb-lg-3 mb-md-3 mb-sm-2 mb-2 animate__animated ${
                isInView ? "animate__fadeIn" : ""
              }`}
            >
              {t("heroSection.subTitle")}
            </h2>
            <p
              className={`DownloadappTxt3 mb-lg-3 mb-md-3 mb-sm-2 mb-3 animate__animated ${
                isInView ? "animate__fadeIn" : ""
              }`}
            >
              {t("heroSection.description")}
            </p>
            <div className="social_container d-flex align-items-center justify-content-center justify-content-lg-start justify-content-md-start">
            <div >
                <a
                  href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                  className=""
                >
                  
                   <img
                    src={AppStore}
                    width="150px"
                    alt="app_store"
                  />
                </a>
                <a
                  href="https://apps.apple.com/app/nitya-mala/id6740871116"
                  className="d-inline-block"
                >
                   
                    <img
                    src={PlayStore}
                    width="150px"
                    alt="play_store"
                  />
                </a>
              </div>
            </div>
            <div className="social_container_footer d-flex align-items-center justify-content-lg-start justify-content-md-start justify-content-center mt-3 p-0">
                <a
                  href="https://www.facebook.com/share/18A1jXhsSW/"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/nityamala_51?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  className="social-icon_footer"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://youtube.com/@nityamala?si=aPVdgzgspapoDRTc"
                  className="social-icon_footer"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <a
                  href="https://t.me/Nityamala"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-telegram"></i>
                </a>
                <a
                  href="https://www.threads.net/@nityamala_51"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-threads"></i>
                </a>
                <a
                  href="https://chat.whatsapp.com/IwRsf8xXaxRErZzn8sVJ1d"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-whatsapp"></i>
                </a>
              </div>
          </Col>

          <Col sm={12} md={6} className="align-items-center py-3">
            <img
              src={mobileImage}
              alt="mobileImage"
              className={`mobileImageHero animate__animated ${
                isInView ? "animate__zoomIn" : ""
              }`}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
